import parse from "html-react-parser";
import {pluralize} from "../utils.mjs";

export default function TokenScoreText({ curTier, nextTier, curTokens, curScore }) {

  const markClass = "px-2 rounded-1 fw-bold";

  let greeting = "";
  let text = "";
  let tokenString = "";
  let scoreString = "";

  //Set up token and score strings
  tokenString = `<mark className="${markClass}">${pluralize(curTokens, "Prime Token")}</mark>`;
  scoreString = `<mark className="${markClass}">${curScore.toLocaleString()} WScore</mark>`;

  //Set the greeting based on the user's tier, tokens, and score
  if (curTokens == 0 && curTier == "play") {
    greeting = "You don't have any Prime Tokens yet!";
    text =
      "Keep playing to reach Escape status and earn your first Prime Token to redeem the Prime Perks below.";
  } else if (curTokens == 0 || curScore < 50000) {
    greeting = "Keep playing!";
    if (curTier == "Fantasy") {
      text = `You have ${tokenString} and ${scoreString}.<br> Earn more WScore in Casinoverse or keep earning WPoints for another Prime Token to redeem the Prime Perks below.`;
    } else {
      text = `Earn more WScore in Casinoverse or reach ${nextTier} status for more Prime Tokens to redeem the Prime Perks below.`;
    }
  } else {
    greeting = "Congrats!";
    text = `You have ${tokenString} and ${scoreString} to redeem the Prime Perks below.`;
  }

  return (
    <div className="token-store-text mb-4">
      <p className="subhead-1 lh-lg mb-2 fw-medium">{parse(greeting)}</p>
      <p className="text-dark-subtle fs-xl lh-lg fw-normal">{parse(text)}</p>
      <p><a href="#prime-perks-rules" className="fs-sm fw-normal">Learn more about Prime Perks Rules</a></p>
    </div>
  );
}
